import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from './assets/img/编组.png'
import _imports_1 from './assets/img/kczj.png'
import _imports_2 from './assets/img/qrcode.jpg'


const _hoisted_1 = { class: "align" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "align" }
const _hoisted_4 = {
  key: 2,
  class: "baise"
}
const _hoisted_5 = { class: "align linhgjf" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fonti1" }, "0371-5608 7886", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fonti2" }, "周一至周六 9:00-24:00", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "img12"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "fonti3 tec1" }, "课程之家公众号", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "img12"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fonti3 tec1" }, "课程之家小程序", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fonti1" }, "应用场景", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fonti1" }, "产品能力", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fonti1" }, "关于我们", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "fonti1" }, "资讯", -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "fonti2 matus" }, "河南总部：河南省国家大学科技园东区8号楼", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "fonti2 matus" }, "北京运营中心：北京市朝阳区北辰西路峻峰华", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fonti2 matus" }, "洛阳运营中心：洛阳市西工区数码大厦A座1", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fonti2 matus" }, "陕西运营中心：陕西省西安市雁塔区团结南路元谷大厦", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "fonti2 matus" }, "商务合作：133 0381 8107", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "fonti2 matus" }, "客服支持：0371-56087886", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "fonti2 matus" }, "课程合作：13526606781", -1)
const _hoisted_24 = {
  key: 3,
  class: "heised"
}
const _hoisted_25 = {
  target: "_blank",
  href: "http://beian.miit.gov.cn"
}
const _hoisted_26 = {
  key: 0,
  style: {"margin-right":"20px"}
}
const _hoisted_27 = {
  key: 1,
  style: {"margin-right":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$route.path == '/')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["hei", $data.scroll == 0 ? '' : 'box']),
          id: "topBannerNav",
          style: _normalizeStyle($data.topBannerNavBg)
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: $data.scroll == 0 ? require('./assets/img/course-logo.png') : require('./assets/img/编组.png'),
                      class: "imgw",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.qies && $options.qies(...args))),
                      style: {"height":"50px","width":"auto"}
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 4,
                          class: _normalizeClass(["waht", [_ctx.$route.path == '/' ? 'befor' : '', $data.scroll == 1 ? 'befor1' : '']])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle($data.topcolor),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.route('/')))
                            }, "五育课程", 4)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_col, {
                          span: 4,
                          class: _normalizeClass(["waht", [_ctx.$route.path == '/mien' ? 'befor' : '', $data.scroll == 1 && _ctx.$route.path == '/mien' ? 'befor1' : '']])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle($data.topcolor),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.route('/mien')))
                            }, "课堂风采", 4)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_col, {
                          span: 4,
                          class: _normalizeClass(["waht", [_ctx.$route.path == '/match' ? 'befor' : '', $data.scroll == 1 && _ctx.$route.path == '/match' ? 'befor1' : '']])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle($data.topcolor),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.route('/match')))
                            }, "活动赛事", 4)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_col, {
                          span: 4,
                          class: _normalizeClass(["waht", [_ctx.$route.path == '/hole' ? 'befor' : '', $data.scroll == 1 && _ctx.$route.path == '/hole' ? 'befor1' : '']])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle($data.topcolor),
                              onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.route('/hole')))
                            }, "研学实践", 4)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_col, {
                          span: 4,
                          class: _normalizeClass(["waht", [_ctx.$route.path == '/after' ? 'befor' : '', $data.scroll == 1 && _ctx.$route.path == '/after' ? 'befor1' : '']])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle($data.topcolor),
                              onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.route('/after')))
                            }, "课后服务", 4)
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "rit"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass($data.scroll == 0 ? 'span' : 'span1'),
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.log && $options.log(...args)))
                    }, "登录", 2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ], 6))
      : _createCommentVNode("", true),
    (_ctx.$route.path != '/'&&_ctx.$route.path != '/course_transcript'&&_ctx.$route.path != '/course_details_transcript'&&_ctx.$route.path != '/course_list_transcript')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "hei box",
          id: "topBannerNav",
          style: _normalizeStyle($data.topBannerNavBg1)
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "imgw",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($options.qies && $options.qies(...args))),
                      style: {"height":"50px","width":"auto"}
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 4,
                          class: _normalizeClass(["waht", _ctx.$route.path == '/' ? 'befor1' : ''])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle($data.topcolor1),
                              onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.route('/')))
                            }, "五育课程", 4)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_col, {
                          span: 4,
                          class: _normalizeClass(["waht", _ctx.$route.path == '/mien' ? 'befor1' : ''])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle($data.topcolor1),
                              onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.route('/mien')))
                            }, "课堂风采", 4)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_col, {
                          span: 4,
                          class: _normalizeClass(["waht", _ctx.$route.path == '/match' ? 'befor1' : ''])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle($data.topcolor1),
                              onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.route('/match')))
                            }, "活动赛事", 4)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_col, {
                          span: 4,
                          class: _normalizeClass(["waht", _ctx.$route.path == '/hole' ? 'befor1' : ''])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle($data.topcolor1),
                              onClick: _cache[11] || (_cache[11] = ($event: any) => ($options.route('/hole')))
                            }, "研学实践", 4)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_col, {
                          span: 4,
                          class: _normalizeClass(["waht", _ctx.$route.path == '/after' ? 'befor1' : ''])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle($data.topcolor1),
                              onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.route('/after')))
                            }, "课后服务", 4)
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "rit"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "span1",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($options.log && $options.log(...args)))
                    }, "登录")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_ctx.$route.meta.keepAlive)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: _ctx.$route.name
              }))
            : _createCommentVNode("", true)
        ], 1024)),
        (!_ctx.$route.meta.keepAlive)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: _ctx.$route.name
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.$route.path != '/mien'&&_ctx.$route.path != '/course_transcript'&&_ctx.$route.path != '/course_details_transcript'&&_ctx.$route.path != '/course_list_transcript')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _hoisted_7,
                    _createVNode(_component_el_row, { class: "mathuy" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _hoisted_9
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _createElementVNode("div", {
                      class: "fonti2 matu",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => ($options.btms(1, 10501)))
                    }, "社团（校本）课管理"),
                    _createElementVNode("div", {
                      class: "fonti2 matu",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => ($options.btms(1, 10502)))
                    }, "课后服务")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createElementVNode("div", {
                      class: "fonti2 matu",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => ($options.btms(1, 10503)))
                    }, "活动课程化"),
                    _createElementVNode("div", {
                      class: "fonti2 matu",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => ($options.btms(1, 10504)))
                    }, "课程优质化"),
                    _createElementVNode("div", {
                      class: "fonti2 matu",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => ($options.btms(1, 10505)))
                    }, "管理数据化")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    _createElementVNode("div", {
                      class: "fonti2 matu",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => ($options.btms(2, 10508)))
                    }, "公司简介"),
                    _createElementVNode("div", {
                      class: "fonti2 matu",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => ($options.btms(2, 10509)))
                    }, "加入我们"),
                    _createElementVNode("div", {
                      class: "fonti2 matu",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => ($options.news()))
                    }, "更多资讯")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.course.value, (list, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "fonti2 matu",
                        key: index,
                        onClick: ($event: any) => ($options.details(list))
                      }, _toDisplayString(list.art_title), 9, _hoisted_16))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 8,
                  class: "matu",
                  style: {"cursor":"context-menu"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _hoisted_18,
                    _hoisted_19,
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 8,
                  class: "matu",
                  style: {"cursor":"context-menu"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$route.path != '/course_transcript'&&_ctx.$route.path != '/course_details_transcript'&&_ctx.$route.path != '/course_list_transcript')
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createTextVNode(" 备案信息："),
          _createElementVNode("a", _hoisted_25, [
            ($data.beian==2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, "豫ICP备17015625号-3 "))
              : _createCommentVNode("", true),
            ($data.beian==1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, "豫ICP备17015625号-7 "))
              : _createCommentVNode("", true)
          ]),
          _createTextVNode("技术支持：河南学明信息科技有限公司 ")
        ]))
      : _createCommentVNode("", true)
  ]))
}